import {
  DocumentReference,
  Query,
  WriteBatch
} from "@firebase/firestore-types";
import { Users } from "@just-in-types";
import { flatMap } from "lodash";
import { firestore } from "../firebase";

const checkInsRef = firestore.collection("checkIns");

const getUserId = async (checkInRef: DocumentReference) => {
  try {
    const doc = await checkInRef.get();
    const checkInData = doc.data() as Users.CheckIn;
    const { userId } = checkInData;

    if (userId) {
      return userId;
    } else {
      throw new Error(`no userId found for checkIn ${checkInRef.id}`);
    }
  } catch (error) {
    throw new Error(error);
  }
};

const deleteUserCheckIns = async (
  userRef: DocumentReference,
  checkInId: string,
  batch: WriteBatch
) => {
  try {
    const userCheckInRef = userRef.collection("checkIns").doc(checkInId);

    batch.delete(userCheckInRef);
  } catch (error) {
    throw new Error(error);
  }
};

export const deleteCheckIn = async (
  checkInId: string,
  voidedByUserId?: string
) => {
  try {
    const checkInRef = checkInsRef.doc(checkInId);
    const userId = await getUserId(checkInRef);
    const userRef = firestore.collection("users").doc(userId);
    const batch = firestore.batch();

    const checkIn = await checkInRef.get();

    const voidedCheckInsRef = firestore.collection("voidedCheckIns");
    voidedCheckInsRef.add(checkIn.data() || {}).then(doc => {
      doc.update({ voidedBy: voidedByUserId, voidedAt: new Date() });
    });

    await deleteUserCheckIns(userRef, checkInId, batch);

    batch.delete(checkInRef);

    return batch.commit();
  } catch (error) {
    throw new Error(error);
  }
};

const deleteCheckIns = async (query: Query) => {
  const querySnapshot = await query.get();
  const checkInIds: string[] = [];

  querySnapshot.forEach(doc => {
    if (doc.exists) {
      checkInIds.push(doc.id);
    }
  });

  const deleteResults: Array<Promise<void>> = [];

  checkInIds.forEach(checkInId => deleteResults.push(deleteCheckIn(checkInId)));

  await Promise.all(deleteResults);

  return checkInIds;
};

export const deleteCheckInsFromBusiness = async (businessId: string) => {
  const query = checkInsRef.where("businessId", "==", businessId);

  const checkInIds = await deleteCheckIns(query);

  return checkInIds;
};

export const deleteCheckInsFromMobile = async (mobile: string) => {
  const query = checkInsRef.where("mobile", "==", mobile);

  const checkInIds = await deleteCheckIns(query);

  return checkInIds;
};

export const deleteTexnCheckIns = async () => {
  const texnMobiles = ["2693529412", "2693529440", "2144557285", "4052064211"];
  const deletePromises: Array<Promise<string[]>> = [];

  texnMobiles.forEach(texnMobile =>
    deletePromises.push(deleteCheckInsFromMobile(texnMobile))
  );

  const checkInIdsNested = await Promise.all(deletePromises);

  const checkInIds = flatMap(checkInIdsNested);

  return checkInIds;
};

export default deleteCheckIn;



// WEBPACK FOOTER //
// ./src/adminFunctions/deleteCheckIn.ts